module.exports = __webpack_public_path__ + "static/media/arrow-right.eb7cd61b.svg";